module.exports = __webpack_public_path__ + "static/media/screenshot-09.da52d825.jpg";